// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-0fQ","col":"styles_col__3x0_M"};